import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: 'blue'
  }
})

const opts = {}

export default new Vuetify(opts)



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js